import React, { useContext } from 'react'
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import InfoForTabs from './InfoForTabs/InfoForTabs';
import governanceDiagram from './governanceDiagram.png';
import qualityDiagram from './qualityDiagram.png'
import lineageDiagram from './lineageDiagram.png'
import strategyDiagram from './strategyDiagram.png'
import designDiagram from './designDiagram.png'
import classes from './DiagramTabs.module.css'
import { ThemeContext } from '../../App';

interface DataItem {
  label: string,
  value: string,
  imageSource: string,
  desc: string,
}

interface DiagramTabsProps {
  diagramTabs: {
    data: DataItem[]
  }
}

const DiagramTabs: React.FC<DiagramTabsProps> = ({
  diagramTabs: { data }, }) => {


  const [activeTab, setActiveTab] = React.useState(data[0]?.value || []);

  const { theme } = useContext(ThemeContext)

  return (
    <div id={classes[theme]} className={classes.container + ' pt-vh20-top lg:pt-vh40-top p-5vwrl lg:p-5vwrl pb-vh10-bottom'}>
      <Tabs value={activeTab}>
        <TabsHeader
          className="rounded-none  bg-transparent p-2 flex-wrap lg:flex-nowrap  text-smTitlesForH md:text-mdTitlesForH lg:text-lgSepBtn2Txt"
          indicatorProps={{
            className:
              "bg-transparent border-b-2 border-blue-400 shadow-none rounded-none",
          }}
        >
          {data.map(({ label, value }) => (
            <Tab
              key={value}
              value={value}
              style={{ cursor: 'pointer' }}
              onClick={() => setActiveTab(value)}
              className={`${classes.headerTabs} border-b  p-3  text-smTitlesForH md:text-mdTitlesForH lg:text-lgSepBtn2Txt mb-2 lg:mb-0 ${activeTab === value ? (theme === "dark" ? 'text-slate-darkPink' : 'text-slate-darkBlue') : ''
                }`}>
              {label}
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody
          animate={{
            initial: { y: 250 },
            mount: { y: 0 },
            unmount: { y: 250 },
          }}
        >
          {data.map(({ value, desc, label, imageSource }) => (
            <TabPanel key={value} value={value}>

              <InfoForTabs imgSrc={imageSource} title={label} desc={desc} />
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs>
    </div>

  );
}

export default DiagramTabs;
